module.exports = __webpack_public_path__ + "img/user.a202d0bb.png";